/**
 * Home Form Method of Payment Wrapper
 * Wraps the shared MethodOfPayment component with home-specific configuration
 */

import SharedMethodOfPayment from 'views/shared/MethodOfPayment/SharedMethodOfPayment';
import { PROPERTY_PAYMENT_OPTIONS } from 'views/shared/MethodOfPayment/configs';
import { SECTIONS } from 'views/home_form/constants';
import {
  changeBilling,
  changeMethodOfPayment,
  updatePayments,
  changeAccountHolder,
  removeMissingMandatoryField,
  changeAgencyBilling,
} from 'reducers/homePersonalFormReducer/homePersonalFormReducer';
import useIsBinderDisabled from 'views/home_form/hooks/useIsBinderDisabled';

// Home-specific field components
import FormInput from 'components/fields/home/FormInput';
import DateInput from 'components/fields/home/DateInput';
import SelectInput from 'components/fields/home/SelectInput';
import RadioInput from 'components/fields/home/RadioInput';

const MethodOfPayment = () => {
  const isDisabled = useIsBinderDisabled();

  return (
    <SharedMethodOfPayment
      formStateKey="homePersonalForm"
      sectionKey={SECTIONS.PREMIUM_INFORMATION}
      paymentConfig={PROPERTY_PAYMENT_OPTIONS}
      isDisabled={isDisabled}
      actions={{
        changeBilling,
        changeMethodOfPayment,
        updatePayments,
        changeAccountHolder,
        removeMissingMandatoryField,
        changeAgencyBilling,
      }}
      components={{
        FormInput,
        DateInput,
        SelectInput,
        RadioInput,
      }}
    />
  );
};

export default MethodOfPayment;
